import type { GameEventDto } from '@rw/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { timeAgo } from '../../lib/format';
import { describeEvent } from './describe-event';
import { useAuth } from '../../stores/auth';
import { colorFor } from '../../lib/colors';
import { useT } from '../../i18n';

export function EventFeed({ events }: { events: GameEventDto[] }) {
  const me = useAuth((s) => s.user?.id ?? null);
  const t = useT();
  const rows = events.map((e) => ({ e, d: describeEvent(e, me) })).filter((r) => r.d);
  if (rows.length === 0) return <p className="py-4 text-center text-sm text-ink-500">{t('No battles yet. Be the first to capture Đà Nẵng.')}</p>;
  return (
    <ul className="divide-y divide-ink-800 overflow-hidden rounded-2xl border border-ink-700/80 bg-ink-850">
      {rows.slice(0, 8).map(({ e, d }) => (
        <li key={e.id}>
          <Row to={e.runId ? `/runs/${e.runId}` : null}>
            <span className="w-5 text-center" style={{ color: colorFor(e.user, me) }}>
              {d!.icon}
            </span>
            <span className="flex-1 text-ink-200">{d!.text}</span>
            <span className="text-xs text-ink-500">{timeAgo(e.createdAt)}</span>
          </Row>
        </li>
      ))}
    </ul>
  );
}

/** Events tied to a run open it (a lost sector opens the run that took it). */
function Row({ to, children }: { to: string | null; children: ReactNode }) {
  const cls = 'flex items-center gap-3 px-4 py-3 text-sm';
  return to ? (
    <Link to={to} className={cls}>
      {children}
    </Link>
  ) : (
    <div className={cls}>{children}</div>
  );
}
